<template>
  <div class="setting-main">
    <div class="mask" @click.stop="$emit('hide')">
      <div class="popup_index" @click.stop="" :class="!isPc ? 'mobile' : 'pc'">
        <div class="" :class="!isPc ? '' : 'account_verification'">
          <div class="popup" :class="!isPc ? 'mobile' : ''">
            <nav class="nav_mobile_top topPadding" v-if="!isPc">
              <div class="nav_content">
                <div class="nav_left">
                  <div class="back" @click="$emit('hide')"><img src="@/assets/img/icon_back.b2094a45.svg" alt="">
                  </div>
                  <div class="logo"><img src="@/assets/img/sax_logo.png" alt="">
                  </div>
                  <div class="nav_name">{{ $t('loan.notVerifyBtn') }}</div>
                </div>
              </div>
            </nav>
            <div class="title" v-if="isPc">{{ $t('loan.notVerifyBtn') }}</div>
            <div class="step1_content" v-show="step == 1">
              <div class="input_item">
                <div class="input_fields " :class="{ active: inputSelect['1'] }">
                  <input type="text" class="input" @focus="inputfocus('1')" @blur="inputblur('1')" size="18"
                    placeholder="" v-model="formData.name" style="font-size: 18px" />
                  <div class="label_name">{{ $t('loan.firstName') }}</div>
                </div>
              </div>
              <div class="input_item">
                <div class="input_fields" :class="{ active: inputSelect['2'] }">
                  <input type="text" class="input" @focus="inputfocus('2')" @blur="inputblur('2')" size="18"
                    placeholder="" v-model="formData.surname" style="font-size: 18px" />
                  <div class="label_name">{{ $t('loan.lastName') }}</div>
                </div>
              </div>
              <div class="input_item">
                <div class="input_select sex" :class="{ active: inputSelect['3'] }">
                  <div class="input_content">
                    <input type="text" class="input" :value="sexGetter" @focus="inputfocus('3')" @blur="inputblur('3')"
                      size="18" placeholder="" style="font-size: 18px" />
                    <img src="@/assets/img/icon_arrow.dc4b9070.svg" alt="">
                    <div class="label_name">{{ $t('loan.sex') }}</div>
                    <div class="select" v-show="sexShow">
                      <div class="option" v-for="(item, index) in sexLIst" :key="index" @click="sexPick(index)"><span>{{
                        item.name }}</span></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="input_item">
                <div class="input_fields" :class="{ active: inputSelect['4'] }">
                  <!-- <input type="text" class="input" @focus="inputfocus('4')" @blur="inputblur('4')" size="18"
                    placeholder="" style="font-size: 18px" /> -->
                  <el-date-picker v-model="formData.birthday" type="date" @focus="inputfocus('4')"
                    @blur="inputblur('4')" :placeholder="$t('loan.birthdate')" 
                    :clearable="false" :editable="false" 
                    :format="'yyyy-MM-dd'" :value-format="'yyyy-MM-dd'"
                    :picker-options="pickerOptions"></el-date-picker>
                  <div class="label_name">{{ $t('loan.birthdate') }}</div>
                </div>
              </div>
              <div class="input_item">
                <div class="input_fields" :class="{ active: inputSelect['5'] }">
                  <input type="text" v-model="formData.country" class="input" @focus="inputfocus('5')"
                    @blur="inputblur('5')" size="18" placeholder="" style="font-size: 18px" />
                  <div class="label_name">{{ $t('loan.country') }}</div>
                </div>
              </div>
              <div class="input_item">
                <div class="input_fields" :class="{ active: inputSelect['6'] }">
                  <input type="text" v-model="formData.address" class="input" @focus="inputfocus('6')"
                    @blur="inputblur('6')" size="18" placeholder="" style="font-size: 18px" />
                  <div class="label_name">{{ $t('loan.address') }}</div>
                </div>
              </div>
              <div class="input_item">
                <div class="input_select" :class="{ active: inputSelect['7'] }">
                  <div class="input_content">
                    <div class="code finger-dark" @click="phoneShowChange"><span>{{ codeList[code] ? codeList[code].label : '+1' }}</span><img
                        src="@/assets/img/icon_arrow.dc4b9070.svg" alt="">
                    </div>
                    <div class="divider"></div>
                    <input class="input" @focus="inputfocus('7')" @blur="inputblur('7')" v-model="formData.phone"
                      size="16" :placeholder="$t('shuRuNinDeDianHuaHaoMa')"
                      onkeyup="this.value=this.value.replace(/[^\d.]/g,'')"
                      onafterpaste="this.value=this.value.replace(/[^\d.]/g,'')" style="font-size: 16px;">
                  </div>
                  <div class="label_name">{{ $t('dianHuaHaoMa') }}</div>
                  <div class="select" v-show="phoneShow">
                    <div class="option" @click="pickCode(index)" v-for="(item, index) in codeList" :key="index"><span>
                        {{ item.label }}
                      </span></div>
                  </div>
                </div>
              </div>
              <!-- <div class="input_item">
                <div class="input_fields" :class="{ active: inputSelect['8'] }">
                  <input type="text" class="input" @focus="inputfocus('8')" @blur="inputblur('8')" size="18"
                    placeholder="" style="font-size: 18px" />
                  <div class="label_name">证件：</div>
                </div>
              </div> -->
              <!-- 选择 身份证 护照 -->
              <div class="input_item">
                <div class="input_select sex card" :class="{ active: inputSelect['8'] }">
                  <div class="input_content">
                    <input type="text" class="input" :value="cardGetter" @focus="inputfocus('8')" @blur="inputblur('8')"
                      size="18" placeholder="" style="font-size: 18px" />
                    <img src="@/assets/img/icon_arrow.dc4b9070.svg" alt="">
                    <div class="label_name">{{ $t('loan.document') }}</div>
                    <div class="select" v-show="cardShow">
                      <div class="option" v-for="(item, index) in cardLIst" :key="index" @click="cardPick(index)"><span>{{
                        item.name }}</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="step2_content" v-show="step == 2">
              <div class="phone_item">
                <div class="item_title">{{ $t('loan.tipIdCardFront') }}</div>
                <!-- <div class="drop-area item_upload" @dragover.prevent @dragenter.prevent @dragleave="dragging = false"
                  @drop.prevent="handleDrop" @click="openFileInput" :class="{ 'drag-over': dragging }">
                  <input ref="fileInput"  @change="handleFileChange" type="file" id="file" accept="image/*" multiple="false" class="file_input">
                  <img src="@/assets/img/icon_upload.5fb30875.svg" alt="">
                  <div class="upload_tips">
                    <div class="main_tip">将图片拖放到此处, 或&nbsp; <span>浏览</span></div>
                    <div class="sub_tip">支持：JPG, JPEG2000, PNG</div>
                  </div>
                </div> -->
                <uploadImg @input="handleFile1" v-model="cardImg1"></uploadImg>
              </div>
              <div class="phone_item">
                <div class="item_title">{{ $t('loan.tipIdCardBack') }}</div>
                <!-- <div class="item_upload">
                  <input type="file" id="file2" accept="image/*" multiple="false" class="file_input">
                  <img src="@/assets/img/icon_upload.5fb30875.svg" alt="">
                  <div class="upload_tips">
                    <div class="main_tip">将图片拖放到此处, 或&nbsp; <span>浏览</span></div>
                    <div class="sub_tip">支持：JPG, JPEG2000, PNG</div>
                  </div>
                </div> -->
                <uploadImg @input="handleFile2" v-model="cardImg2"></uploadImg>
              </div>
              <!-- <div class="phone_item">
                <div class="item_title">{{ $t('loan.tipIdCardBack') }}</div>
              
                <uploadImg @input="handleFile3" v-model="cardImg3"></uploadImg>
              </div> -->
            </div>
            <div class="submit_content" v-show="step == 1">
              <div class="submit_btn">
                <div @click="setpChange()" class="button " :class="!isPc ? 'black' : 'yellow round'" style="padding: 0px 36px">
                  <span style="font-size: 20px">{{ $t('board.continue') }}</span>
                </div>
              </div>
            </div>
            <div class="submit_content" v-show="step == 2">
              <div class="submit_btn">
                <div @click="handUserAuth()" class="button " :class="!isPc ? 'black' : 'yellow round'"  style="padding: 0px 36px" :disabled="submitting">
                  <span style="font-size: 20px" v-if="!submitting">{{ $t('loan.submit') }}</span>
                  <!-- <span style="font-size: 20px" v-else>提交中...</span> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import uploadImg from "@/components/uploadImg.vue";
import { DatePicker } from 'element-ui';
import { userAuth } from "@/api/user.js";
import { mapState } from "vuex";
export default {
  components: {
    'el-date-picker': DatePicker,
    uploadImg
  },
  computed: {
    ...mapState(["isPc", "areaCodes"]),
    // 区号列表 - 使用统一的格式，兼容原有代码
    codeList() {
      return this.areaCodes.map(code => ({
        label: code,
        value: code.replace('+', '')
      }));
    },
    sexGetter() {
      if (this.formData.sex) {
        return this.sexLIst.find(item => item.value==this.formData.sex).name
      } else {
        return ""
      }
    },
    cardGetter() {
      if (this.formData.idType) {
        return this.cardLIst.find(item => item.value==this.formData.idType).name
      } else {
        return ""
      }
    },
    // 性别列表
    sexLIst() {
      return [
        { name: this.$t('loan.male'), value: "1" },
        { name: this.$t('loan.female'), value: "2" },
      ]

    },
    // 证件列表
    cardLIst() {
      return [
        { name: this.$t('loan.idCard'), value: "1" },
        { name: this.$t('loan.passport'), value: "2" },
        {name: this.$t('loan.driverLicense'), value: "3"}
      ]
    },
  },
  data() {
    return {
      cardImg1: "",//身份证正面
      cardImg2: "",//身份证反面
      cardImg3: "",//手持身份证
      dragging: false,
      mask: false,
      submitting: false, // 添加提交状态
      // 邮箱显示隐藏
      phoneShow: false,
      // 期限显示
      limitShow: false,
      limit: 0,
      // 验证身份表单
      formData: {
        phone: "",
        sex: "",
        idType: "",
      },
      code: 0, // 改为索引，对应第一个区号
      // 证件显示隐藏
      cardShow: false,
      sexShow: false,
      inputSelect: {},
      step: 1,
      // 日期选择器配置
      pickerOptions: {
        disabledDate(time) {
          // 禁用未来日期
          return time.getTime() > Date.now();
        }
      }
    };
  },
  methods: {
    setpChange() {
      if (!this.formData.surname||!this.formData.name||!this.formData.country||!this.formData.sex||!this.formData.address||!this.formData.phone||!this.formData.birthday||!this.formData.idType) {
        this.$toast({
          message: this.$t('qingTianXieWanZhengXinXi'),
          type: 'warning'
        });
        return
      }
      this.step=2
    },
    handleFile1(file) {
      this.cardImg1=file;
    },
    handleFile2(file) {
      this.cardImg2=file;
    },
    handleFile3(file) {
      this.cardImg3=file;
    },
    handUserAuth() {
      // 防止重复提交
      if (this.submitting) {
        return;
      }

      let code=this.codeList[this.code] ? this.codeList[this.code].value : this.codeList[0].value;
      let params={
        surname: this.formData.surname,
        name: this.formData.name,
        country: this.formData.country,
        sex: this.formData.sex,
        address: this.formData.address,
        phone: code+this.formData.phone,
        birthday: this.formData.birthday,
        idType: this.formData.idType,
        // idNumber: this.formData.idNumber,
        frontImg: this.cardImg1,
        reverseImg: this.cardImg2,
        // handImg: this.cardImg3,
      }
      
      // 调试信息
      //console.log('调试信息:', {
      //   codeIndex: this.code,
      //   codeListLength: this.codeList.length,
      //   codeListAtIndex: this.codeList[this.code],
      //   codeValue: code,
      //   phoneInput: this.formData.phone,
      //   fullPhone: params.phone,
      //   frontImg: this.cardImg1,
      //   reverseImg: this.cardImg2
      // });
      
      // 改进表单验证
      if (!params.surname||!params.name||!params.country||!params.sex||!params.address||!params.phone||!params.birthday||!params.idType||!params.frontImg||!params.reverseImg) {
        this.$toast({
          message: this.$t('qingTianXieWanZhengXinXi'),
          type: 'warning'
        });
        return
      }

      // 验证手机号格式 - 只验证为纯数字
      const phoneRegex = /^\d+$/;
      if (!phoneRegex.test(params.phone)) {
        this.$toast({
          message: this.$t('qingTianXieZhengQueDeDianHuaHaoMa'),
          type: 'warning'
        });
        return
      }

      this.submitting = true;
      
      userAuth(params).then(res => {
        this.submitting = false;
        // //console.log(res);
        if (res.code==200) {
          this.$toast({
            message: this.$t('tiJiaoChengGong'),
            type: 'success'
          });
          this.$emit('hide')
        } else {
          this.$toast({
            message: this.$t(res.message) || res.msg || '提交失败，请重试',
            type: 'warning'
          });
        }
      }).catch(error => {
        this.submitting = false;
        console.error('实名认证提交失败:', error);
        this.$toast({
          message: '网络错误，请检查网络连接后重试',
          type: 'error'
        });
      });

    },
    cardPick(index) {
      this.formData.idType=this.cardLIst[index].value;
      // //console.log(this.formData.idType);
      this.cardShow=false;
    },
    sexPick(index) {
      // // //console.log(111);
      this.formData.sex=this.sexLIst[index].value;
      // //console.log(this.formData.sex);
      this.sexShow=false;
    },
    inputfocus(index) {
      this.inputSelect[index]=true;
      // //console.log(this.inputSelect);
      if (index==3) {
        this.sexShow=true
      }
      if (index==8) {
        this.cardShow=true
      }
      this.$forceUpdate()
    },
    inputblur(index) {
      this.inputSelect[index]=false
      // if (index == 3) {
      //   this.sexShow=false;
      // }
      this.$forceUpdate()
    },
    phoneShowChange() {
      this.phoneShow=!this.phoneShow
    },
    pickCode(index) {
      this.code=index
      // //console.log(this.code);
      this.phoneShow=false
    },
  },
}
</script>
<style scoped lang="scss">
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  overflow-y: auto;
  


  .account_verification.mobile {
    width: 100%;
    height: 100%;
    border-radius: 0;
    overflow: auto
  }

}

.account_verification {
  background: #fff;
  border-radius: .18rem
}

.popup {
  padding: .44rem;
  width: 8.62rem;
  box-sizing: border-box
}

.popup .title {
  margin-bottom: .48rem;
  text-align: left;
  font-weight: 700;
  font-size: .34rem;
color: var(--primary-color, #0156DC);
}

.popup .step1_content {
  margin-bottom: .18rem;
  display: flex;
  flex-wrap: wrap
}

.popup .step1_content .input_item {
  margin-bottom: .22rem;
  width: 100%
}

.popup .step1_content .input_item:nth-child(odd) {
  margin-right: 0
}

.popup .step2_content {
  margin-bottom: .4rem;
  display: flex;
  justify-content: space-around
}

.popup .step2_content .phone_item:first-child {
  margin-right: .14rem
}

.popup .step2_content .phone_item:nth-child(2) {
  margin-right: .14rem
}


.popup .step2_content .phone_item .item_title {
  padding: 0 .4rem;
  margin-bottom: .22rem;
  font-weight: 500;
  font-size: .16rem;
  color: var(--primary-color, #0156DC);
  text-align: center;
}

.popup .step2_content .phone_item .item_upload {
  padding: .24rem 0;
  border: .01rem dashed #000;
  border-radius: .2rem;
  text-align: center
}

.popup .step2_content .phone_item .item_upload .file_input {
  display: none
}

.popup .step2_content .phone_item .item_upload .upload_tips {
color: var(--primary-color, #0156DC);
}

.popup .step2_content .phone_item .item_upload .upload_tips .main_tip {
  font-size: .16rem
}

.popup .step2_content .phone_item .item_upload .upload_tips .main_tip span {
  cursor: pointer;
  color: #4d4fff
}

.popup .step2_content .phone_item .item_upload .upload_tips .sub_tip {
  margin-top: .1rem;
  color: rgba(0, 0, 0, .5);
  font-size: .14rem
}

.popup .step2_content .phone_item .item_upload_resilt {
  width: .72rem;
  height: .72rem
}

.popup .step3_content {
  margin-bottom: .4rem;
  padding: .24rem .44rem .36rem .44rem;
  border: .01rem solid #000;
  border-radius: .2rem;
  display: flex;
  flex-direction: column;
  align-items: center
}

.popup .step3_content .item_upload_resilt {
  width: 3.78rem;
  height: 1.72rem
}

.popup .step3_content .file_input {
  display: none
}

.popup .step3_content .idcard_content {
  margin-bottom: .18rem;
  width: 1.26rem;
  height: 1.26rem;
  background: #000;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center
}

.popup .step3_content .idcard_content img {
  width: .6rem;
  height: .6rem
}

.popup .step3_content .idcard_img {
  margin-bottom: .18rem;
  width: 1.26rem;
  height: 1.26rem
}

.popup .step3_content .tips {
  margin-bottom: .18rem;
  padding: 0 .8rem;
  font-weight: 400;
  font-size: .18rem
}

.popup .step3_content .tips span {
  cursor: pointer;
  color: #4d4fff;
  white-space: nowrap
}

.popup .step4_content {
  margin-bottom: .4rem
}

.popup .step4_content .status_title {
  font-weight: 500;
  font-size: .24rem;
  color: var(--primary-color, #0156DC);
  display: flex;
  align-items: center;
  justify-content: center
}

.popup .step4_content .status_title .status_icon {
  margin-left: .08rem;
  width: .26rem;
  height: .26rem;
  border-radius: 50%;
  background: #00c308;
  display: flex;
  justify-content: center;
  align-items: center
}

.popup .step4_content .status_title .status_icon img {
  width: .14rem;
  height: auto
}

.popup .step4_content .status_content {
  margin-top: .16rem;
  font-size: .18rem;
  text-align: center;
  color: rgba(0, 0, 0, .6)
}

.popup .submit_content {
  display: flex
}

.popup .submit_content .submit_btn {
  height: .42rem
}

.popup.step3 {
  width: 6.54rem
}


.popup.mobile {
  padding: 0 .24rem;
  padding-top: 1.02rem;
  padding-bottom: .4rem;
  width: 100%;
}

.popup.mobile .step1_content .input_item {
  width: 100%
}

.popup.mobile .step1_content .input_item:nth-child(odd) {
  margin-right: 0
}

.popup.mobile .step2_content {
  flex-direction: column
}

.popup.mobile .step2_content .phone_item {
  width: 100%
}

.popup.mobile .step2_content .phone_item:first-child {
  margin-right: 0;
  margin-bottom: .5rem
}

.popup.mobile .step2_content .phone_item:nth-child(2) {
  margin-right: 0;
  margin-bottom: .5rem
}

.popup.mobile .step2_content .phone_item .item_title {
  padding: 0 .2rem
}

.popup.mobile .step3_content {
  margin-bottom: .24rem;
  padding: .24rem
}

.popup.mobile .step3_content .actions .action_btn {
  height: .48rem
}

.popup.mobile .step3_content .actions .action_btn:first-child {
  margin-bottom: .16rem
}

.popup.mobile .step4_content {
  margin-bottom: .24rem;
  padding: .24rem;
  border: .01rem solid #000;
  border-radius: .2rem
}

.popup.mobile .step4_content .status_title {
  font-weight: 500;
  font-size: .24rem;
  color: var(--primary-color, #0156DC);
  display: flex;
  align-items: center;
  justify-content: center
}

.popup.mobile .step4_content .status_title .status_icon {
  margin-left: .08rem;
  width: .26rem;
  height: .26rem;
  border-radius: 50%;
  background: #00c308;
  display: flex;
  justify-content: center;
  align-items: center
}

.popup.mobile .step4_content .status_title .status_icon img {
  width: .14rem;
  height: auto
}

.popup.mobile .step4_content .status_content {
  margin-top: .16rem;
  font-size: .18rem;
  text-align: center;
  color: rgba(0, 0, 0, .6)
}

.popup.mobile .submit_content {
  display: flex;
  justify-content: center
}

.popup.mobile .submit_content .submit_btn {
  height: .68rem
}




.input_fields {
  position: relative;
  width: 100%;
  height: .68rem;
  box-sizing: border-box;
  border: .02rem solid rgba(0, 0, 0, .2);
  border-radius: .2rem
}

.input_fields .input {
  width: 100%;
  height: 100%;
  border-radius: .2rem;
  box-sizing: border-box;
  padding: 0 .28rem;
  border: unset;
  outline: none;
  color: #000;
  font-weight: 500;
  caret-color: #000
}

.input_fields .input::placeholder {
  color: rgba(0, 0, 0, .5)
}

.input_fields .input:disabled {
  color: rgba(0, 0, 0, .5)
}

.input_fields .label_name {
  padding: 0 .06rem;
  position: absolute;
  top: -.15rem;
  left: .26rem;
  font-weight: 500;
  font-size: .18rem;
  color: rgba(0, 0, 0, .5);
  background: #fff
}

.input_fields.active {
  border: .02rem solid 3A69FA
}

.input_fields.active .label_name {
color: var(--primary-color, #0156DC);
}

.input_select {
  position: relative;
  width: 100%;
  height: .68rem;
  box-sizing: border-box;
  border: .02rem solid rgba(0, 0, 0, .2);
  border-radius: .2rem
}

.input_select .input_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: .2rem;
  height: 100%;
  padding-right: .26rem
}

.input_select .input_content .input {
  flex: 1;
  height: 100%;
  border-radius: .2rem;
  padding: 0 .28rem;
  color: #000;
  font-weight: 500;
  caret-color: #000
}

.input_select .input_content .input::placeholder {
  color: rgba(0, 0, 0, .5)
}

.input_select .input_content img {
  width: .12rem;
  height: auto
}

.input_select .label_name {
  padding: 0 .06rem;
  position: absolute;
  top: -.15rem;
  left: .26rem;
  font-weight: 500;
  font-size: .18rem;
  color: rgba(0, 0, 0, .5);
  background: #fff
}

.input_select .select {
  position: absolute;
  left: 0;
  width: 100%;
  max-height: 3.2rem;
  box-sizing: border-box;
  background: #fff;
  border: 0.01rem solid rgba(0, 0, 0, .2);
  border-radius: 0.1rem;
  z-index: 99;
  overflow: auto;
  bottom: 0.84rem !important;
}

.input_select .select .option {
  cursor: pointer;
  padding: 0 .28rem;
  height: .48rem;
  line-height: .48rem;
  text-align: left
}

.input_select .select .option:hover {
  background: rgba(0, 0, 0, .1)
}

.input_select.active {
  border: .02rem solid 3A69FA
}

.input_select.active .label_name {
color: var(--primary-color, #0156DC);
}

.input_select {
  position: relative;
  width: 100%;
  height: .68rem;
  box-sizing: border-box;
  border: .02rem solid rgba(0, 0, 0, .2);
  border-radius: .2rem
}

.input_select .input_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: .2rem;
  height: 100%;
  padding: 0 .28rem
}

.input_select .input_content .code {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: .18rem;
  color: #000
}

.input_select .input_content .code span {
  padding-bottom: .04rem
}

.input_select .input_content .code img {
  margin-left: .08rem;
  width: .08rem;
  height: auto
}

.input_select .input_content .divider {
  margin-left: .14rem;
  margin-right: .18rem;
  width: 0;
  height: .18rem;
  border: .01rem solid rgba(0, 0, 0, .2)
}

.input_select .input_content .input {
  flex: 1;
  height: 100%;
  border-radius: .2rem;
  color: #000;
  font-weight: 500;
  caret-color: #000
}

.input_select .input_content .input::placeholder {
  color: rgba(0, 0, 0, .5)
}

.input_select .label_name {
  padding: 0 .06rem;
  position: absolute;
  top: -.15rem;
  left: .26rem;
  font-weight: 500;
  font-size: .18rem;
  color: rgba(0, 0, 0, .5);
  background: #fff
}

.input_select .select {
  position: absolute;
  bottom: .76rem;
  left: 0;
  width: 100%;
  max-height: 3.2rem;
  box-sizing: border-box;
  background: #fff;
  border: .01rem solid rgba(0, 0, 0, .2);
  border-radius: .1rem;
  z-index: 99;
  overflow: auto
}

.input_select .select .option {
  cursor: pointer;
  padding: 0 .28rem;
  height: .48rem;
  line-height: .48rem;
  text-align: left
}

.input_select .select .option:hover {
  background: rgba(0, 0, 0, .1)
}

.input_select.active {
  border: .02rem solid 3A69FA
}

.input_select.active .label_name {
color: var(--primary-color, #0156DC);
}

.input_fields {
  position: relative;
  width: 100%;
  height: .68rem;
  box-sizing: border-box;
  border: .02rem solid rgba(0, 0, 0, .2);
  border-radius: .2rem
}

.input_fields .el-input {
  width: 100%;
  height: 100%;
  border-radius: .2rem;
  box-sizing: border-box;
  border: unset;
  outline: none;
  color: var(--primary-color, #0156DC);
  font-weight: 500;
  caret-color: #000;

}

.input_fields :deep(.el-input__wrapper) {
  box-shadow: none;
  background: none;
  border: none !important;
  height: 0.68rem;

  .el-icon svg {
    height: 1em !important;
    width: 1em !important;
  }
}

.input_fields :deep(.el-input__inner) {
  border: none !important;
  background: none;
  line-height: 0.6rem;
  color: var(--primary-color, #0156DC);
  margin-top: 10px;
  font-size: 18px;
}


.input_fields .el-input::placeholder {
  color: rgba(0, 0, 0, .5)
}

.input_fields .el-input .el-input__wrapper .el-input__inner {
color: var(--primary-color, #0156DC);
}

.input_fields .el-input .el-input__wrapper:hover {
  box-shadow: none;
  background: none
}

// 移动端日期选择器样式优化
@media (max-width: 768px) {
  .input_fields .el-date-picker {
    width: 100%;
  }
  
  .input_fields :deep(.el-input__wrapper) {
    height: 0.68rem;
    display: flex;
    align-items: center;
  }
  
  .input_fields :deep(.el-input__inner) {
    height: 100%;
    line-height: 0.68rem;
    margin-top: 0;
    font-size: 18px;
  }
  
  .input_fields :deep(.el-input__suffix) {
    display: flex;
    align-items: center;
  }
}

.input_fields .label_name {
  padding: 0 .06rem;
  position: absolute;
  top: -.15rem;
  left: .26rem;
  font-weight: 500;
  font-size: .18rem;
  color: rgba(0, 0, 0, .5);
  background: #fff
}

.input_fields.active {
  border: .02rem solid 3A69FA
}

.input_fields.active .label_name {
color: var(--primary-color, #0156DC);
}

.box[data-v-2a86ad2b] {
  width: 5rem;
  height: 4rem;
  margin: auto
}

.sex .select {
  position: absolute;
  top: 0.68rem;
  left: 0;
  width: 100%;
  max-height: 2.4rem;
  box-sizing: border-box;
  background: #fff;
  border: 0.01rem solid rgba(0, 0, 0, .2);
  border-radius: 0.1rem;
  z-index: 99;
  overflow: auto;
  height: 1rem;
}
.card .select{
  height: 1.5rem;
}

// .popup.mobile {
//     padding: 0 0.24rem;
//     padding-top: 3rem;
//     padding-bottom: 0.4rem;
//     width: 100%;
// }
.popup_index {
    background: #fff;
    border-radius: .18rem
}

.popup_index.mobile {
    width: 100%;
    height: 100%;
    border-radius: 0;
    overflow: auto
}

// 添加按钮禁用状态样式
.button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}
</style>